import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { LoginService } from 'src/app/service/login.service';
import { MessagesService } from 'src/app/service/messages.service';
import { LanguageService } from 'src/app/service/language.service';

const correoRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [MessageService]
})
export class LoginComponent implements OnInit, AfterViewInit {
  email: string = '';
  password: string = '';
  showPassword: boolean = false;
  

  constructor(
    private router: Router,
    private messageService: MessageService,
    private loginservice: LoginService,
    private message: MessagesService,
    private languageService: LanguageService
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit() {
    const passwordInput = document.getElementById('password') as HTMLInputElement;
    passwordInput.addEventListener('input', () => {
      this.password = passwordInput.value;
    });
  }

  iniciarSesion() {
    if (this.email === "") {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: this.languageService.translateInstant('EMAIL_REQUIRED') });
      return;
    }
    if (!correoRegExp.test(this.email)) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: this.languageService.translateInstant('INVALID_EMAIL') });
      return;
    }
    if (this.password === "") {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: this.languageService.translateInstant('PASSWORD_REQUIRED') });
      return;
    }
    const user = {
      "email": this.email,
      "password": this.password
    }
    this.loginservice.userLogin(user).then(value => {
      this.messageService.add({ severity: 'success', summary: 'Exito', detail: this.languageService.translateInstant('LOGIN_SUCCESS') });
      this.routeToHome();
      this.message.setDispositivo(null);
    })
      .catch(error => {
        if (!error.error) {
          console.error("Error en login", error);
          this.messageService.add({ severity: 'error', summary: 'Error', detail: this.languageService.translateInstant('LOGIN_ERROR') });
          return;
        }
        const errorResponse = error.error;
        const title = this.obtenerMensajeTitulo(errorResponse.value);

        this.messageService.add({ severity: 'error', summary: title, detail: errorResponse.message });
        // Actualizar la URL para asegurarse de que el parámetro de idioma se mantiene
        this.languageService.setLanguage(this.languageService.getLanguage());
      });
  }

  routeToHome(): void {
    const isPasswordRestored = this.loginservice.chatCrmUser.passwordRestore;
    const url = isPasswordRestored ? "/account" : "/dashboard";
    this.router.navigate([url], { queryParams: { lang: this.languageService.getLanguage() } });
  }

  private obtenerMensajeTitulo(value: number): string {
    switch (value) {
      case 1: return this.languageService.translateInstant('USER_NOT_FOUND');
      case 2: return this.languageService.translateInstant('PASSWORD_ERROR');
      case 3: return this.languageService.translateInstant('ACCOUNT_ERROR');
    }
    return "";
  }

  quitarEspacios(event: any) {
    this.email = event.value.trim();
    event.value = this.email;
  }

  togglePasswordVisibility(passwordInput: HTMLInputElement) {
    this.showPassword = !this.showPassword;
    passwordInput.type = this.showPassword ? 'text' : 'password';
  }

  navigateRestarPassword(lang: string): void {
    this.router.navigate(['/restore-password'], {
      queryParamsHandling: 'merge'
    });
  }
}
